const UnauthedLayout = (props) => <>{props.children}</>
export default UnauthedLayout